const LS_PREFIX = 'mdv-layer-panel-ui';

function storageKey(projectName) {
  return `${LS_PREFIX}:${String(projectName || 'default')}`;
}

const DEFAULT = {
  activeTab: 'browse',
  expandedPaths: [],
  scrollByTab: {},
  searchText: '',
};

const TAB_IDS = new Set(['browse', 'holes', 'visible', 'cached', 'recent', 'blockmodels']);

function normalizeActiveTab(tab) {
  if (tab === 'filter') return 'blockmodels';
  return TAB_IDS.has(tab) ? tab : DEFAULT.activeTab;
}

export function readLayerPanelUi(projectName) {
  try {
    const raw = localStorage.getItem(storageKey(projectName));
    if (!raw) return { ...DEFAULT };
    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object') return { ...DEFAULT };
    const scrollByTab =
      data.scrollByTab && typeof data.scrollByTab === 'object' ? { ...data.scrollByTab } : {};
    if (scrollByTab.filter != null && scrollByTab.blockmodels == null) {
      scrollByTab.blockmodels = scrollByTab.filter;
    }
    return {
      activeTab: normalizeActiveTab(data.activeTab || DEFAULT.activeTab),
      expandedPaths: Array.isArray(data.expandedPaths) ? data.expandedPaths : [],
      scrollByTab,
      searchText: typeof data.searchText === 'string' ? data.searchText : '',
    };
  } catch {
    return { ...DEFAULT };
  }
}

export function writeLayerPanelUi(projectName, patch) {
  try {
    const prev = readLayerPanelUi(projectName);
    localStorage.setItem(
      storageKey(projectName),
      JSON.stringify({
        ...prev,
        ...patch,
        savedAt: new Date().toISOString(),
      })
    );
  } catch {
    // quota or private mode
  }
}
